import React from "react";

function SlidingText({ text, className = "" }) {
  return (
    <div className={`overflow-hidden ${className}`}>
      <div
        className="flex whitespace-nowrap"
        style={{
          animation: "slide 20s linear infinite",
          width: "fit-content",
        }}
      >
        <span className="inline-block">{text}</span>
        <span className="inline-block ml-8">{text}</span>
        <span className="inline-block ml-8">{text}</span>
        <span className="inline-block ml-8">{text}</span>
        <span className="inline-block ml-8">{text}</span>
        <span className="inline-block ml-8">{text}</span>
        <span className="inline-block ml-8">{text}</span>
        <span className="inline-block ml-8">{text}</span>
        <span className="inline-block ml-8">{text}</span>
        <span className="inline-block ml-8">{text}</span>
        <span className="inline-block ml-8">{text}</span>
        <span className="inline-block ml-8">{text}</span>
      </div>
      <style jsx>{`
        @keyframes slide {
          from {
            transform: translateX(0);
          }
          to {
            transform: translateX(-33.333%);
          }
        }
      `}</style>
    </div>
  );
}

export default SlidingText;
